import { call, takeLatest, delay } from 'redux-saga/effects';

/*
  [this is a blocking function, this must be called in parallel in page root saga along with other watcher by using yield all]

  This is a custom debounce function that cancels previous process when new action is received through takeLatest
  debounce behaviour is achieved with delay

  for consecutive actions if the response from first request comes after the response from second request
  due to network activity or query time, reducer gets updated with first request's response when debounce is used
  debounce by default does not cancel previous process when new action is received

  this function is to be used instead of debounce when response time between two function can vary a lot

  for example table data search where if table data is large and result for searched value is small
  then full table data query results may take longer time to get back to client than searched query results

  @param {Number} ms desired millisecond time delay between consecutive actions
  @param {String} pattern that listener sage listens to
  @param {generator function} workerSage generator function that is called when given action pattern is received
 */
function* customDebounce(ms, pattern, workerSage) {
  yield takeLatest(pattern, debouncedSaga);

  function* debouncedSaga(action) {
    yield delay(ms);
    yield call(workerSage, action);
  }
}

export default customDebounce;
